import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { Badge } from "@/components/ui/badge"
import { MapPin, Users, Zap, TrendingUp, Plus } from "lucide-react"

export default function Territorios() {
  const territorios = [
    {
      id: 1,
      nome: "São Paulo Capital",
      regiao: "Grande São Paulo",
      responsavel: "Ana Vendedora",
      clientes: 45,
      leads: 23,
      instalacoes: 12,
      potencial: "8.5 kW",
      performance: "Excelente",
      meta: 15,
      atingido: 12
    },
    {
      id: 2,
      nome: "Campinas",
      regiao: "Interior SP",
      responsavel: "Carlos Vendedor",
      clientes: 32,
      leads: 18,
      instalacoes: 8,
      potencial: "6.2 kW",
      performance: "Boa",
      meta: 10,
      atingido: 8
    },
    {
      id: 3,
      nome: "Santos",
      regiao: "Litoral SP",
      responsavel: "Maria Vendedora",
      clientes: 28,
      leads: 15,
      instalacoes: 6,
      potencial: "4.8 kW",
      performance: "Regular",
      meta: 8,
      atingido: 6
    },
    {
      id: 4,
      nome: "Sorocaba",
      regiao: "Interior SP",
      responsavel: "João Vendedor",
      clientes: 19,
      leads: 12,
      instalacoes: 4,
      potencial: "3.2 kW",
      performance: "Em Desenvolvimento",
      meta: 6,
      atingido: 4
    }
  ]

  const getPerformanceColor = (performance: string) => {
    switch (performance) {
      case "Excelente": return "default"
      case "Boa": return "secondary"
      case "Regular": return "outline"
      case "Em Desenvolvimento": return "destructive"
      default: return "secondary"
    }
  }

  return (
    <div className="space-y-6 p-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-foreground">Territórios</h1>
          <p className="text-muted-foreground">Gestão regional e performance por área</p>
        </div>
        <Button className="gap-2">
          <Plus className="h-4 w-4" />
          Novo Território
        </Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-medium">Total Territórios</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{territorios.length}</div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-medium">Total Clientes</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">
              {territorios.reduce((acc, t) => acc + t.clientes, 0)}
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-medium">Leads Ativos</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-warning">
              {territorios.reduce((acc, t) => acc + t.leads, 0)}
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-medium">Instalações Totais</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold text-success">
              {territorios.reduce((acc, t) => acc + t.instalacoes, 0)}
            </div>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <MapPin className="h-5 w-5" />
            Performance por Território
          </CardTitle>
          <CardDescription>
            Análise regional de vendas e instalações
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            {territorios.map((territorio) => (
              <div key={territorio.id} className="p-4 border border-border rounded-lg space-y-4">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="font-semibold">{territorio.nome}</h3>
                    <p className="text-sm text-muted-foreground">{territorio.regiao}</p>
                  </div>
                  <Badge variant={getPerformanceColor(territorio.performance)}>
                    {territorio.performance}
                  </Badge>
                </div>
                
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  <div className="text-center p-3 bg-muted/30 rounded-lg">
                    <Users className="h-5 w-5 mx-auto mb-1 text-muted-foreground" />
                    <div className="text-lg font-semibold">{territorio.clientes}</div>
                    <div className="text-xs text-muted-foreground">Clientes</div>
                  </div>
                  <div className="text-center p-3 bg-muted/30 rounded-lg">
                    <TrendingUp className="h-5 w-5 mx-auto mb-1 text-muted-foreground" />
                    <div className="text-lg font-semibold">{territorio.leads}</div>
                    <div className="text-xs text-muted-foreground">Leads</div>
                  </div>
                  <div className="text-center p-3 bg-muted/30 rounded-lg">
                    <Zap className="h-5 w-5 mx-auto mb-1 text-muted-foreground" />
                    <div className="text-lg font-semibold">{territorio.instalacoes}</div>
                    <div className="text-xs text-muted-foreground">Instalações</div>
                  </div>
                  <div className="text-center p-3 bg-muted/30 rounded-lg">
                    <MapPin className="h-5 w-5 mx-auto mb-1 text-muted-foreground" />
                    <div className="text-lg font-semibold">{territorio.potencial}</div>
                    <div className="text-xs text-muted-foreground">Potencial</div>
                  </div>
                </div>

                <div className="flex items-center justify-between text-sm">
                  <span>Responsável: <strong>{territorio.responsavel}</strong></span>
                  <span>Meta: {territorio.atingido}/{territorio.meta} instalações</span>
                </div>

                <div className="flex gap-2">
                  <Button variant="outline" size="sm">
                    Ver Mapa
                  </Button>
                  <Button variant="outline" size="sm">
                    Relatório Detalhado
                  </Button>
                  <Button variant="outline" size="sm">
                    Alterar Responsável
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Resumo Regional</CardTitle>
          <CardDescription>
            Performance consolidada por região
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="p-4 border border-border rounded-lg">
              <h4 className="font-semibold text-success">Grande São Paulo</h4>
              <p className="text-2xl font-bold">45 clientes</p>
              <p className="text-sm text-muted-foreground">1 território ativo</p>
            </div>
            <div className="p-4 border border-border rounded-lg">
              <h4 className="font-semibold text-warning">Interior SP</h4>
              <p className="text-2xl font-bold">51 clientes</p>
              <p className="text-sm text-muted-foreground">2 territórios ativos</p>
            </div>
            <div className="p-4 border border-border rounded-lg">
              <h4 className="font-semibold text-info">Litoral SP</h4>
              <p className="text-2xl font-bold">28 clientes</p>
              <p className="text-sm text-muted-foreground">1 território ativo</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
